import calculateQuoteModal from './calculateQuoteModal.html';

/* @ngInject */
export default function ($scope, LayoutService, Quoting, toastr, $state, moment, $uibModal, AuthService, PreferencesService) {
	AuthService.redirectIfUnauthorized('view-quoting', 'splash.home');

	LayoutService.setTitle('New Quote');
	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-fw fa-calculator"></i> Calculate Quote</button>');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'staff.quoting.root',
			             displayName: 'Quotes',
		             },
		             {
			             route:       'staff.quoting.new',
			             displayName: 'New Quote',
		             },
	             ]);

	$scope.loadingTotal     = false;
	$scope.loadingProviders = false;
	$scope.services         = [];
	$scope.providers        = {};

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.maskOptions = {
		maskDefinitions: {
			'h': /[0-2]/,
			'H': /\d/,
			'm': /[0-5]/,
			'M': /\d/,
		},
	};

	$scope.states = [
		'NSW',
		'ACT',
		'VIC',
		'QLD',
		'TAS',
		'SA',
		'WA',
		'NT',
	];

	$scope.periods = [
		'Weekly',
		'Fortnightly',
		'Monthly',
	];

	$scope.commonShifts = [
		{
			start: 7,
			end:   8,
		},
		{
			start: 7,
			end:   9,
		},
		{
			start: 8,
			end:   9,
		},
		{
			start: 8,
			end:   10,
		},
		{
			start: 9,
			end:   12,
		},
		{
			start: 9,
			end:   17,
		},
	];

	$scope.showWeeks = 1;

	$scope.quote = {
		start:                 moment()
			                       .startOf('day'),
		end:                   moment()
			                       .add(1, 'month')
			                       .startOf('day'),
		state:                 'NSW',
		period:                'Weekly',
		title:                 '',
		comment:               '',
		excludePublicHolidays: false,
	};

	$scope.enquiries        = [];
	$scope.loadingEnquiries = true;

	$scope.periodChanged = () => {
		switch ($scope.quote.period) {
			case 'Weekly': {
				$scope.showWeeks = 1;

				break;
			}

			case 'Fortnightly': {
				$scope.showWeeks = 2;

				break;
			}

			case 'Monthly': {
				$scope.showWeeks = 4;

				break;
			}
		}

		$scope.updateWeeks();
	};

	$scope.updateWeeks = () => {
		$scope.services.forEach((item) => {
			while ($scope.providers[item.provider][item.service].length < 4) {
				$scope.providers[item.provider][item.service].push({
					'Sunday':    [],
					'Monday':    [],
					'Tuesday':   [],
					'Wednesday': [],
					'Thursday':  [],
					'Friday':    [],
					'Saturday':  [],
				});
			}
		});
	};

	$scope.addShift = (provider, service, weekIndex, day, start, end) => {
		$scope.providers[provider][service][weekIndex][day].push({
			start: (start !== null) ? (('00' + start.toString()).substring(start.toString().length) + '00') : (null),
			end:   (end !== null) ? (('00' + end.toString()).substring(end.toString().length) + '00') : (null),
		});
	};

	$scope.removeShift = (provider, service, weekIndex, day, shiftIndex) => {
		$scope.providers[provider][service][weekIndex][day].splice(shiftIndex, 1);
	};

	$scope.refresh = () => {
		$scope.loadingProviders = true;
		$scope.loadingEnquiries = true;
		Quoting
			.services()
			.getList()
			.then((data) => {
				$scope.services  = data;
				$scope.providers = {};

				data.forEach((item) => {
					if (!$scope.providers.hasOwnProperty(item.provider)) {
						$scope.providers[item.provider] = {};
					}

					if (!$scope.providers[item.provider].hasOwnProperty(item.service)) {
						$scope.providers[item.provider][item.service] = [];
					}
				});

				$scope.loadingProviders = false;

				$scope.updateWeeks();
			});
		Quoting.getEnquiries()
		       .getList()
		       .then((data) => {
			       $scope.enquiries        = data;
			       $scope.loadingEnquiries = false;
		       })
		       .catch((error) => {
			       toastr.clear();
			       toastr.error('There was an error while retrieving the enquiry list. Please try again.', 'Error');
		       });

	};

	$scope.calculateQuote = () => {
		const modalInstance = $uibModal.open({
			animation:                  true,
			template:                   calculateQuoteModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance, toastr, Quoting, $state) => {
				$scope.showCostPerHour = false;
				$scope.loadingQuote    = true;
				$scope.savingQuote     = false;

				// Deep clone the shifts
				let shifts = JSON.parse(JSON.stringify($scope.providers));

				const uniqueServices = $scope.services.filter((service, index, self) => {
					return self.indexOf(service) === self.findIndex((item) => {
						return service.provider === item.provider && service.service === item.service;
					});
				});

				uniqueServices.forEach((item) => {
					shifts[item.provider][item.service].forEach((week, weekIndex) => {
						Object.entries(week)
						      .forEach(([dayIndex, day]) => {
							      Object.entries(day)
							            .forEach(([shiftIndex, shift]) => {
								            shifts[item.provider][item.service][weekIndex][dayIndex][shiftIndex] = {
									            start: {
										            hour:   parseInt(shift.start.substring(0, 2), 10),
										            minute: parseInt(shift.start.substring(2), 10),
									            },
									            end:   {
										            hour:   parseInt(shift.end.substring(0, 2), 10),
										            minute: parseInt(shift.end.substring(2), 10),
									            },
								            };
							            });
						      });
					});
				});

					const quote = {
						start:                 moment($scope.quote.start)
							                       .local()
							                       .format('YYYY-MM-DD'),
						end:                   moment($scope.quote.end)
							                       .local()
							                       .format('YYYY-MM-DD'),
						state:                 $scope.quote.state,
						period:                $scope.quote.period,
						shifts:                shifts,
						title:                 $scope.quote.title,
						comment:               $scope.quote.comment,
						excludePublicHolidays: $scope.quote.excludePublicHolidays,
						enquiry:               $scope.quote.enquiry,
					};

				$scope.cancel = () => {
					$uibModalInstance.close();
				};

				$scope.saveQuote = () => {
					$scope.savingQuote = true;

					Quoting.post(quote)
					       .then((data) => {
						       $uibModalInstance.close();

						       $scope.savingQuote = false;

						       toastr.clear();
						       toastr.success('Your quote was successfully saved.', 'Success');

						       $state.go('staff.quoting.root');
					       })
					       .catch((data) => {
						       $uibModalInstance.close();

						       $scope.savingQuote = false;

						       toastr.clear();
						       toastr.error('There was an error while saving your quote, please check your input and try again.', 'Error');
					       });
				};

				$scope.toggleCostPerHour = () => {
					$scope.showCostPerHour = !$scope.showCostPerHour;
				};

					Quoting.calculateQuote(quote)
					       .then((data) => {
						       $scope.calculatedQuote = data.data;

						       $scope.loadingQuote = false;
					       })
					       .catch((data) => {
						       $uibModalInstance.close();

						       $scope.loadingQuote = false;

						       toastr.clear();
						       toastr.error('There was an error while calculating your quote, please check your input and try again.', 'Error');
					       });
				},
			},
		);
	};

	LayoutService.getPageHeader()
	             .onClicked($scope.calculateQuote);

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/quoting/new/controller.js